export interface OrderRedux {
  menu_id: number;
  menu_name : string;
  type: string;
  sweetness: number;
  remark: string;
  tumblerImage: string;
}

const initialState: OrderRedux  = {
  menu_id: 0,
  menu_name : '',
  type: "",
  sweetness: 0,
  remark: "",
  tumblerImage: "",
};

export type OrderAction =
  | {
      type: "SETMENU";
      payload: OrderRedux;
    }
  | {
      type: "CLEAR";
    };

export const orderReducer = (state: OrderRedux = initialState, action: OrderAction) => {
  switch (action.type) {
    case "SETMENU":
      return action.payload;
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};
